import RowMetas from "../RowMetas/RowMetas"
import "./Metas.css"


import consultMetasIcon from '../../assets/img/admin-consult-metas.png'

function Metas({ metas, filtros, manageAnimal }) {

    const isDisabled = 
        !filtros.idfiliais || 
        !filtros.id_tipo_metas || 
        !filtros.mes || 
        !filtros.ano ||
        metas.length < 1

    return (
        <div className='metas-consulta-wrapper'>
            <div className={`header ${isDisabled ? 'disabled' : ''}`}>
                <span>2</span>
                <h1>Consultar metas</h1>
            </div>
            <div className={`body ${isDisabled ? 'disabled' : ''}`}>
                <table className="adm-table metas-animais">
                    <thead>
                        <tr>
                            <th className="expand-icon-column">
                            </th>
                            <th>Nome</th>
                            <th>Indicador</th>
                            <th className="tipo-column">Tipo</th>
                            <th>Status</th>
                            <th className="acao-column">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {metas.length 
                            ? metas.map(meta => <RowMetas key={meta.id_animal} selectedYear={meta.ano || filtros.ano} selectedMonth={meta.mes || filtros.mes} meta={meta} manageMetas={() => manageAnimal(meta.id_animal, meta.ano || filtros.ano, meta.mes || filtros.mes)}/>) 
                            : ''
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Metas